// UI slice that tracks whether the Client/Co-Client profile form has
// unsaved (dirty) input.
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileEditState {
    hasUnsavedProfileChanges: boolean;
    // True while an Accounts/Income row is open in add/edit mode (regardless of dirty state).
    // Drives disabling "Continue to Next Step" on Step 1 the moment an account/income row is edited.
    hasOpenAccountsEdit: boolean;
}

const initialState: ProfileEditState = {
    hasUnsavedProfileChanges: false,
    hasOpenAccountsEdit: false
};

const profileEditSlice = createSlice({
    name: 'profileEdit',
    initialState,
    reducers: {
        setHasUnsavedProfileChanges: (state, action: PayloadAction<boolean>) => {
            if (state.hasUnsavedProfileChanges !== action.payload) {
                state.hasUnsavedProfileChanges = action.payload;
            }
        },
        setHasOpenAccountsEdit: (state, action: PayloadAction<boolean>) => {
            if (state.hasOpenAccountsEdit !== action.payload) {
                state.hasOpenAccountsEdit = action.payload;
            }
        }
    }
});

export const { setHasUnsavedProfileChanges, setHasOpenAccountsEdit } = profileEditSlice.actions;

export default profileEditSlice.reducer;
